import Box from '@mui/material/Box';
import { map } from 'lodash';
import GetDocumentContainer from '@/components/common/documents-box/get-document-container';
import DocumentBoxItem from '@/components/common/documents-box/document-box-item';
import FixedDocumentBoxItem from '@/components/common/documents-box/fixed-document-box-item';

interface Props {
    items: {
        label: string;
        subLabel?: string;
        tag?: string;
        fixedUrlDownload?: string;
    }[];
    withUploadButton?: boolean;
}

const DocumentsBox = ({ items, withUploadButton = true }: Props) => (
    <Box
        sx={{
            display: 'grid',
            gap: 4,
            gridTemplateColumns: 'repeat(3, auto)',
            justifyContent: 'center',
            justifyItems: 'center',
        }}
    >
        {map(items, ({ label, tag = '', fixedUrlDownload, subLabel }) =>
            fixedUrlDownload ? (
                <FixedDocumentBoxItem
                    label={label}
                    fixedUrlDownload={fixedUrlDownload}
                    key={fixedUrlDownload}
                    subLabel={subLabel}
                />
            ) : (
                <GetDocumentContainer tag={tag} key={tag}>
                    {({ file, isLoadingFile, refetch }: any) => (
                        <DocumentBoxItem
                            label={label}
                            file={file}
                            isLoadingFile={isLoadingFile}
                            tag={tag}
                            refetch={refetch}
                            subLabel={subLabel}
                            withUploadButton={withUploadButton}
                        />
                    )}
                </GetDocumentContainer>
            ),
        )}
    </Box>
);

export default DocumentsBox;
